import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zh from './zh'
import es from './es'
Vue.use(VueI18n)

const messages = {
  es: {
    ...es
  },
  zh_cn: {
    ...zh
  }
}
const i18n = new VueI18n({
  locale: 'es',
  messages: messages
})
export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js